import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import BasicBackground from '../BasicBackground';
import Errored from '../Errored';
import Loading from '../Loading';
import PrimaryButton from '../PrimaryButton';
import { registrationService } from '../services/security/registrationService';
import { globalStyles as styles } from '../style/gstheme';
import { makeCancelable, processHashLocation } from '../utils/utils';

class GetStarted extends Component {

  constructor(props) {
    super(props);
    this.state = {
      id: "",
      confirmationId: "",
      confirming: false,
      ready: false,
      isErrored: null
    };
    this.textInput = React.createRef();
    this.cancellable = null;
  }

  componentDidMount() {
    const paramsMap = processHashLocation(this.props.location);
    const id = paramsMap.get("id");
    const confirmationId = paramsMap.get("confirmationId");
    const isInvalid = !id || id === "" || !confirmationId || confirmationId === "";
    if (isInvalid) this.props.history.push("/");
    this.setState({ id, confirmationId }, () => this.checkStatus());
  }

  componentWillUnmount() {
    if (this.cancellable) this.cancellable.cancel();
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
  }

  goToLogin = () => {
    this.props.history.push("/login#status=firstvisit");
  };

  checkStatus = async () => {
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
    try {
      const response = await this.doCheckStatus().promise;
      if (this.cancellable && this.cancellable.isCancelled()) return;
      if (response.exists === true && response.confirmed === true) {
        // All good - ready for loging
        this.setState({ ready: true });
        return;
      }
      else {
        if (response.exists === false) {
          this.props.history.push("/");
          return;
        }
        this.hcTimeout = setTimeout(() => {
          this.checkStatus();
        }, 2000);
      }
    }
    catch (e) {
      if (this.cancellable && this.cancellable.isCancelled()) return;
      let message = ["I'm afraid we can't process your registration confirmation.", "The server may be down temporarily."];
      this.setState({
        isErrored: { message },
        confirming: false,
        processing: false
      });
      return;
    }
  };

  doCheckStatus() {
    const { id, confirmationId } = this.state;
    this.cancellable = makeCancelable(registrationService.confirmationStatus(id, confirmationId));
    return this.cancellable;
  }

  render() {

    const { classes } = this.props;
    const { isErrored, ready } = this.state;

    if (isErrored) return <Errored data={isErrored} />;

    return (
      <BasicBackground>
        <div style={{ width: '100%', position: 'absolute', top: 100, textAlign: 'center' }}>
          {ready ?
            <div>
              <Typography className={classes.mainHeadingLight}>Your Account is Ready</Typography>
              <PrimaryButton onClick={this.goToLogin}>Proceed to Login</PrimaryButton>
            </div>
            :
            <div>
              <Typography className={classes.mainHeadingLight}>Finalising Your Account ... Please Wait</Typography>
              <Loading />
            </div>
          }
        </div>
      </BasicBackground>
    );
  }
}

GetStarted.propTypes = {
  classes: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object
};

export default withRouter(withStyles(styles)(GetStarted));